/**
 * Types mirroring tilt-admin-api response shapes.
 *
 * For Admin-0 these are hand-written. Admin-1a bootstraps a codegen step
 * (FastAPI OpenAPI → openapi-typescript) so every route gets typed from
 * the backend spec automatically. Keeping this file lean + explicit on
 * purpose until that's wired - easier to hand-edit than to over-engineer.
 */
/** Thrown by the client on 4xx / 5xx. Carries status + parsed body. */
export class ApiError extends Error {
    status;
    body;
    constructor(status, body, message) {
        super(message ?? `API ${status}`);
        this.name = "ApiError";
        this.status = status;
        this.body = body;
    }
}
//# sourceMappingURL=types.js.map